import angular from 'angular'

import LocalizationFactory from './localization.factory'

let module = angular.module('localization', [])
.factory('Localization', LocalizationFactory)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/localization/index.js